import api from './api';

/**
 * ТЗ №1 §4: единственный analytics route. from/to обязаны быть timezone-aware
 * (naive → 422), signal — AbortSignal для отмены устаревшего запроса.
 *
 * SCOPE-MULTI01 (ТЗ v4 §21): помимо legacy factory_id роут принимает массивы
 * factory_ids / workshop_ids / section_ids / room_ids / camera_ids / rule_ids,
 * а также per-table параметры control_* / comparison_* / shift_*. Здесь они
 * просто пробрасываются: union внутри уровня, intersection между уровнями и
 * ACL считает backend.
 *
 * Пустые значения и пустые массивы отбрасываются — «Все» по контракту это
 * отсутствие параметра, а не перечисление всех доступных ID.
 */
export const cleanAnalyticsParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => {
      if (value === undefined || value === null || value === '') return false;
      if (Array.isArray(value)) return value.length > 0;
      return true;
    })
  );

export const getExecutiveSummary = (params = {}, { signal } = {}) =>
  api.get('/analytics/executive-summary', {
    params: cleanAnalyticsParams(params),
    signal,
  }).then((r) => r.data);
